<template>
  <div class="page">
  </div>
</template>

<script>
  import {login, isLogin} from '@/api/login'
  import {setToken, setUserid, setSessionKey} from '@/utils/auth'

  export default {
    data(){
      return{
      }
    },
    created() {
      //判断是否登录
      this.isCheckLogin();
    },
    methods: {
      // 判断是否登录
      isCheckLogin(){
        let sessionkey = this.$route.query.sessionkey;
        if(sessionkey!=null && sessionkey!=""){
          let data = {code: sessionkey};
          login(data).then(response => {
            const tokenStr = response.data.token;
            const useridStr = response.data.userid;
            setToken(tokenStr);
            setUserid(useridStr);
            setSessionKey(this.sessionkey);
            // 跳转到影片列表
            this.$router.push({path: '/filmList'})
          });
        }else{
          let data = {};
          isLogin(data).then(response => {
            // 跳转到影片列表
            this.$router.push({path: '/filmList'})
          });
        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/views/index.vue